module.exports = __webpack_public_path__ + "static/img/blast.e544a45.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/blast.png
// module id = 7dRe
// module chunks = 128